import { __rest } from 'tslib';
import React__default from 'react';
import { CommonStyles } from './components/BaseProps.es.js';
import { m as mergeCls } from './utils-f1412689.js';
import { styled } from '@teko/styled';

const StyledCard = styled.div(({ theme }) => [
    CommonStyles,
    `
  border-radius: 8px;
  background-color: ${theme.colors.white};
  position: relative;
`,
]);
const CardHeader = styled.div ``;
const CardBody = styled.div ``;
const CardFooter = styled.div ``;
const Card = React__default.forwardRef((_a, ref) => {
    var { children, header, footer, className } = _a, props = __rest(_a, ["children", "header", "footer", "className"]);
    return (React__default.createElement(StyledCard, Object.assign({ className: mergeCls('teko-card', className), ref: ref }, props),
        header && React__default.createElement(CardHeader, { className: "teko-card-header" }, header),
        React__default.createElement(CardBody, { className: "teko-card-body" }, children),
        footer && React__default.createElement(CardFooter, { className: "teko-card-footer" }, footer)));
});
Card.displayName = 'Card';

export { Card as C };
